import { useTranslation } from '@pancakeswap/localization'
import { ReactNode } from 'react'
import { Typography } from '@/components/ui/typography'
import { OutOfRangeTooltip } from '@/components/tooltips/out-of-range'

export function RangeTag({
  removed,
  outOfRange,
  children,
  ...props
}: {
  removed?: boolean
  outOfRange: boolean
  children?: ReactNode
}) {
  const { t } = useTranslation()

  return removed ? (
    <Typography variant="tip" {...props}>
      {children || t('Closed')}
    </Typography>
  ) : outOfRange ? (
    <Typography variant={'tip'} className={'text-destructive'} {...props}>
      {children || (
        <div className={'flex items-center gap-1'}>
          {t('Out of Range')} <OutOfRangeTooltip />
        </div>
      )}
    </Typography>
  ) : (
    <Typography variant="tip" className={'text-green-500'} {...props}>
      {children || t('In Range')}
    </Typography>
  )
}
